import React from 'react';
import './Table.css';

const ProjectTable = ({ 
  projects, 
  onProjectSelect, 
  selectedProject, 
  selectedProjectIds,
  onToggleSelection,
  onToggleSelectAll,
  onEdit, 
  onDelete,
  isAuthenticated
}) => {
  const headerCheckboxRef = React.useRef();

  // Helper to format date string
  const formatDate = (dateString) => {
    if (!dateString) return '';
    return dateString.split('T')[0];
  };

  React.useEffect(() => {
    if (headerCheckboxRef.current) {
      const numSelected = selectedProjectIds.size;
      const numProjects = projects.length;
      headerCheckboxRef.current.checked = numSelected === numProjects && numProjects > 0;
      headerCheckboxRef.current.indeterminate = numSelected > 0 && numSelected < numProjects;
    }
  }, [selectedProjectIds, projects.length]);

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>
              <input 
                type="checkbox"
                ref={headerCheckboxRef}
                onChange={onToggleSelectAll}
              />
            </th>
            <th>项目名称</th>
            <th>项目经理</th>
            <th>开始日期</th>
            <th>结束日期</th>
            <th>进度</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {projects.map(project => (
            <tr 
              key={project.id}
              // A row is "active" if it's the one showing tasks below
              className={selectedProject?.id === project.id ? 'active' : ''}
            >
              <td>
                <input 
                  type="checkbox" 
                  checked={selectedProjectIds.has(project.id.toString())} 
                  onChange={() => onToggleSelection(project.id.toString())}
                />
              </td>
              <td onClick={() => onToggleSelection(project.id.toString())}>{project.name}</td>
              <td>{project.manager}</td>
              <td>{formatDate(project.startDate)}</td>
              <td>{formatDate(project.endDate)}</td>
              <td>
                <div className="progress-bar-container">
                    <div className="progress-bar" style={{ width: `${project.progress}%` }}>
                        {project.progress}%
                    </div>
                </div>
              </td>
              <td>{project.status}</td>
              <td>
                {isAuthenticated && (
                  <>
                <button className="btn btn-sm btn-secondary" onClick={(e) => { e.stopPropagation(); onEdit(project); }}>编辑</button>
                <button className="btn btn-sm btn-danger" onClick={(e) => { e.stopPropagation(); onDelete(project.id); }}>删除</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectTable; 